import { combineReducers } from "redux";
import authReducer from './auth/reducers';
import pageReducer from './page/reducers';
import userReducer from './user/reducers';
import locationReducer from './location/reducers';
import eventReducer from "./events/reducers";
import cartReducer from "./cart/reducers";

export default combineReducers({
  auth: authReducer,
  page: pageReducer,
  user: userReducer,
  location: locationReducer,
  events: eventReducer,
  cart: cartReducer
})